import { Box, Button, Center, Heading, Text } from "@chakra-ui/react";
import Dropzone from "react-dropzone";
import { FormattedMessage } from "react-intl";

import { Mode } from "@nens/ldo/api-v1";

interface SelectFilesProps {
  active: boolean;
  mode: Mode | null;
  done: boolean;
  files: File[];
  filesValid: boolean;
  nextStep(): void;
  addFiles(files: File[]): void;
  removeFile(f: File): void;
}

export function SelectFiles({
  active,
  mode,
  done,
  files,
  filesValid,
  nextStep,
  addFiles,
  removeFile,
}: SelectFilesProps) {
  if ((!active && !done) || mode === null) {
    return null;
  }

  return (
    <Box>
      {active ? (
        <Dropzone onDrop={addFiles}>
          {({ getRootProps, getInputProps }) => (
            <Center m={4} color="bij12_1.700" bgColor="white" borderRadius={4} border="dashed 2px">
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <Heading m={4}>
                  <FormattedMessage
                    id="steps.download.drag_or_click_to_select"
                    defaultMessage="Drag file(s) or click to select them"
                  />
                </Heading>
              </div>
            </Center>
          )}
        </Dropzone>
      ) : null}
      {files.map((file) => (
        <Text mx={4} key={file.name}>
          {active ? (
            <Button m={4} onClick={() => removeFile(file)}>
              Remove
            </Button>
          ) : null}
          {file.name} ({file.size} bytes){" "}
        </Text>
      ))}
      {active && filesValid ? (
        <Button m={4} onClick={nextStep}>
          Start import
        </Button>
      ) : null}
    </Box>
  );
}
